import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { cookingTypeOptions } from './constants'
import Select from 'react-select'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const CornMasaFlourPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    CookingType: item.CookingType,
    Size: item.Size,
  })

  const methods = useFormContext()
  const { onChangeReviewer, setSelectReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { category, subCategory, CookingType, Size } = item
      setPackaging({
        category,
        subCategory,
        CookingType,
        Size,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <h6>Cooking Type {asterisk}</h6>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={cookingTypeOptions}
            name="CookingType"
            placeholder="Select Cooking Type"
            defaultValue={{
              label: packaging.CookingType,
              value: packaging.CookingType,
            }}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            control={methods.control}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="CookingType"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Controller
            as={Input}
            name="Size"
            placeholder={'12 - 48 ounces'}
            defaultValue={packaging.Size}
            control={methods.control}
            rules={{
              validate: Size => Size >= 12 && Size <= 48,
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              message={'⚠ Size must be between 12 - 48 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

CornMasaFlourPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default CornMasaFlourPackageReview
